module.exports = __webpack_public_path__ + "img/party.72bbf01e.png";